import { Delete, Save } from "@mui/icons-material";
import { Box, Grid, IconButton, TextField, colors } from "@mui/material";
import trash from "../../assets/sound/trash.mp3";
import React, { useEffect, useState } from "react";
import { deleteDoc, doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import LineChart from "./LineChart";
import CloseIcon from "@mui/icons-material/Close";
const ProductChart = ({ id, title }) => {
  const [chartRun, setChartRun] = useState(false);
  const [data, setData] = useState([]);

  const handleClose = () => {
    setChartRun(false);
  };

  const handleButton = async () => {
    const docRefId = doc(db, "productStat", id);
    const docSnap = await getDoc(docRefId);
    if (docSnap.exists()) {
      setData([
        docSnap.data().d202301,
        docSnap.data().d202302,
        docSnap.data().d202303,
        docSnap.data().d202304,
        docSnap.data().d202305,
        docSnap.data().d202306,
        docSnap.data().d202307,
        docSnap.data().d202308,
        docSnap.data().d202309,
        docSnap.data().d202310,
        docSnap.data().d202311,
        docSnap.data().d202312,
      ]);
    }

    setChartRun(true);
  };

  return (
    <Grid container spacing={4}>
      <Grid item xs={1} sm={12}>
        <IconButton onClick={handleButton}>
          <PlayCircleIcon sx={{ width: 80, height: 80, color: "purple" }} />
        </IconButton>
        <IconButton onClick={handleClose}>
          <CloseIcon sx={{ width: 80, height: 80, color: "red" }} />
        </IconButton>
      </Grid>
      <Grid item xs={1} sm={12}>
        {chartRun ? <LineChart data={data} title={title} /> : ""}
      </Grid>
    </Grid>
  );
};

export default ProductChart;
